import styles from './ModalSpinner.sass'
import * as React from 'react'
import Spinner from '../../../../../../components/Spinner'

export default function ModalSpinner() {
  return (
    <div className={styles.spinner}>
      <Spinner size={36} thickness={2} />
    </div>
  )
}
